<onwac-modal 
[title]="'MULTIUPLOAD.title' | translate" 
[show]="toggler.show"
(callback)="getModalResult($event)">
    <div slot="content" class="modal-body">
        <app-progress-bar [options]="{
            'showText': true,
            'backgroundColor': '#1a2d4b',
            'callback': false,
            'customText': 'MULTIUPLOAD.uploadingDocuments' | translate
        }"></app-progress-bar>
        <ng-container *ngFor="let uploadCategory of categoryCluster; let i = index;">
            <div class="mb-md">
                <div *ngIf="categories" class="category-selector">
                    <onwac-input 
                      [type]="'select'" 
                      [label]="'FUNNEL.dealPage.documentStrings.editCategory' | translate"
                      [input_name]="'category_docs_'+i"
                      [submitted]="submitted"
                      [parentForm]="docsForm"
                      [select_items]="categories"
                      [selected_index]="0"
                      (onChangeSelect)="getCategory($event, i)"></onwac-input>
                    <p *ngIf="categoryCluster.length > 1" class="help-text link" (click)="deleteCategoryCluster(i)">{{ 'MULTIUPLOAD.deleteCategory' | translate }}</p>
                </div>
        
                <p class="small color-base-50">{{ 'MULTIUPLOAD.title' | translate }}</p>
                <div class="custom-dropzone" ngx-dropzone (change)="onSelect($event, i)">
                    
                    <div class="dropzone__message">
                        <p class="small">
                            {{ 'MULTIUPLOAD.modalText' | translate }}
                        </p>
                        <i class="material-icons notranslate">backup</i>
                    </div>
                    
        
                </div>
                <div class="file-zone">
                    <div class="d-flex justify-content-between mt-sm" *ngIf="uploadCategory.documents.length > 0">
                        <p class="small mb-0">
                            {{uploadCategory.documents.length}} {{ 'MULTIUPLOAD.documents' | translate }} 
                        </p>
                        <p class="cursor small  mb-0 color-accent" (click)="uploadCategory.toggleDocuments()">{{ 'MULTIUPLOAD.showHide' | translate }}</p>
                    </div>
                    <div *ngIf="uploadCategory.getShowDocuments">
                        <app-custom-preview 
                        ngProjectAs="ngx-dropzone-preview" 
                        *ngFor="let document of uploadCategory.documents; let j = index" 
                        [file]="document.file" 
                        [private]="document.internal" 
                        [removable]="true" 
                        (onChangePrivacity)="changePrivacity($event, i, j)" 
                        (removed)="onRemove(i, j)">
                        </app-custom-preview>
                    </div>
                </div>
            </div>
            </ng-container>
            <div *ngIf="categories" class="d-flex align-items-center cursor" (click)="addNewCategoryCluster()">
                <onwac-button 
                [type]="'icon'" 
                [icon]="'add_circle'" 
                ></onwac-button>
                <p class="action-text w-icon small mb-0">{{ 'MULTIUPLOAD.addDocsInOtherCat' | translate }}</p>
            </div>
            <ng-container *ngIf="!categories">
                <p class="small color-base-50">{{ 'MULTIUPLOAD.title' | translate }}</p>
                <div class="custom-dropzone" ngx-dropzone (change)="onSelect($event, i)">
                    
                    <div class="dropzone__message">
                        <p class="small">
                            {{ 'MULTIUPLOAD.modalText' | translate }}
                        </p>
                        <i class="material-icons notranslate">backup</i>
                    </div>
                    
        
                </div>
                <div class="file-zone">
                    <app-custom-preview 
                    ngProjectAs="ngx-dropzone-preview" 
                    *ngFor="let file of files; let i = index" 
                    [file]="file" 
                    [removable]="true" 
                    (removed)="onRemoveSingle(i)">
                    </app-custom-preview>
                </div>
            </ng-container>
    </div>
    <div class="button-row full-width" slot="footer">
        <onwac-button [text]="'MULTIUPLOAD.cancel' | translate" [type]="'text'" [extra_clases]="'block'" (click)="getModalResult(false)"></onwac-button>
        <onwac-button [text]="'MULTIUPLOAD.save' | translate" [extra_clases]="'block'" [disabled]="files.length == 0" (click)="getModalResult(true)"></onwac-button>
    </div>
</onwac-modal>
